export default __webpack_public_path__ + "static/media/firebase-real-time-database.997b7b3b.png";